import styled from 'styled-components';
import { Anchor } from '@zillow/constellation-10';
import { token } from '@zillow/constellation';

export const SkipNavigationLink = styled(Anchor)`
    align-items: center;
    border-bottom: 1px solid ${token('colors.gray200')};
    display: flex;
    font-weight: bold;
    height: 1px;
    justify-content: center;
    left: -9999px;
    overflow: hidden;
    position: absolute;
    text-align: center;
    text-decoration: underline;
    width: 1px;
    z-index: -500;

    &:focus,
    &:active {
        background: #fff;
        height: 51px;
        left: auto;
        outline: 0;
        overflow: visible;
        width: 100%;
        z-index: 1001;

        > span {
            outline: auto;
        }
    }

    > span {
        white-space: nowrap;
    }
`;
